import { Stack } from "react-bootstrap";

import { useMutation, useQuery } from "../../hooks";
import UserForm from "./UserForm";
import { UserInterface, UserMutationResponse } from "./types";

export default function Signup() {
  const { data: user } = useQuery("users/1");
  const mutation = useMutation("users", "1", "PATCH") as UserMutationResponse;

  function handleSubmit(values: UserInterface) {
    mutation.mutate(values);
  }

  const buttons = (dirty: boolean) => (
    <button className="button" type="submit" disabled={!dirty}>
      Save
    </button>
  );

  if (!user) return null;

  return (
    <Stack className="col-md-8 col-lg-6 mx-auto">
      <h2>Profile</h2>
      <UserForm
        buttons={buttons}
        mutationResponse={mutation}
        onSubmit={handleSubmit}
        user={user}
      />
    </Stack>
  );
}
